var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.3102 0H2.66204C1.95602 0 1.27892 0.274226 0.779694 0.762351C0.280464 1.25048 0 1.91252 0 2.60283L0 21.5016L18.9699 2.92535C15.3067 8.78738 17.3611 14.7116 20.301 17.2409C17.3611 14.7116 12.3148 14.3156 9.31715 15.9395C7.23381 17.0712 6.35418 18.8535 6.65511 21.4733C6.99076 24.3987 9.98266 26 11.9792 26H13.3102C16.7292 25.844 19.9553 24.4062 22.3184 21.9854C24.6815 19.5645 26 16.3465 26 13C26 9.65346 24.6815 6.43553 22.3184 4.01464C19.9553 1.59375 16.7292 0.155991 13.3102 0Z"}));
}

Logo.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"color"};

module.exports = Logo;

Logo.default = Logo;
